export function useCms() {
  return useNuxtApp().$cms;
}
